import React from "react";
import { components } from "react-select";
import { TerritoryIcons } from "../../../Utils/Constants";

export default function MenuList(props) {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option, i) => (
        <div
          key={i}
          className="territory-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          <img src={TerritoryIcons[option.value]} alt="type" />
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Brand/components/MenuList.js